<template style="height: 100%;">
  <div class="Personal_file">

    <div class="Personal_file_left">
      <h1>个人信息</h1>
      <ul>

        <li :style="{ background: activeStep == 1 ? 'rgb(235, 236, 237)' : '#ffffff' }" @click="jupm('General', '1')"> <i style="width: 30px;height: 30px;border-radius: 8px;background-color: rgba(242, 158, 0, 1);text-align: center;line-height: 30px;margin-left: 20px;color: #fff;font-size: 16px;" class="el-icon-user"></i> 一般信息</li>

        <li :style="{ background: activeStep == 2 ? 'rgb(235, 236, 237)' : '#ffffff' }" @click="jupm('Grow', '2')"><i style="width: 30px;height: 30px;border-radius: 8px;background-color: rgba(77, 191, 138, 1);text-align: center;line-height: 30px;margin-left: 20px;color: #fff;font-size: 16px;" class="el-icon-sugar"></i> 个人成长史</li>

        <li :style="{ background: activeStep == 3 ? 'rgb(235, 236, 237)' : '#ffffff' }" @click="jupm('Army', '3')"><i style="width: 30px;height: 30px;border-radius: 8px;background-color: rgba(92, 114, 226, 1);text-align: center;line-height: 30px;margin-left: 20px;color: #fff;font-size: 16px;" class="el-icon-wind-power"></i> 军旅新路</li>

        <li :style="{ background: activeStep == 3 ? 'rgb(235, 236, 237)' : '#90' }" @click="jupm('Army', '4')"><i style="width: 30px;height: 30px;border-radius: 8px;background-color: rgba(92, 114, 226, 1);text-align: center;line-height: 30px;margin-left: 20px;color: #fff;font-size: 16px;" class="el-icon-wind-power"></i> 咨询记录</li>

        <li :style="{ background: activeStep == 3 ? 'rgb(235, 236, 237)' : '#ffffff' }" @click="jupm('Army', '5')"><i style="width: 30px;height: 30px;border-radius: 8px;background-color: rgba(92, 114, 226, 1);text-align: center;line-height: 30px;margin-left: 20px;color: #fff;font-size: 16px;" class="el-icon-wind-power"></i> 重要事件</li>

        <li :style="{ background: activeStep == 3 ? 'rgb(235, 236, 237)' : '#ffffff' }" @click="jupm('Army', '6')"><i style="width: 30px;height: 30px;border-radius: 8px;background-color: rgba(92, 114, 226, 1);text-align: center;line-height: 30px;margin-left: 20px;color: #fff;font-size: 16px;"  class="el-icon-wind-power"></i> 军旅新路</li>

      </ul>
    </div>

    <div style="height: 100%;">
      <File_individual v-if="Judgment == '1'" />
      <File_record_list style="height: 100%;" v-if="Judgment == '2'" />
    </div>
  
  </div>

</template>
<script>

import File_individual from '../Archives_management/File_individual.vue';
import File_record_list from '../Archives_management/File_record_list.vue';

export default {
  data() {
    return {
      Judgment: '2',
      form: {
        Bring: [{
          StartAge: '',//开始年龄
          EndAge: '', //结束年龄
          Supporter: '', //扶养人
        }],
        ExperienceBeforeAmry: '',//入伍前工作经历
        ArmyCause: '',//入伍动机
        IndividualTraits: '',//个性特征
        AdaptStateTime: '',//入伍后适应情况及时间
        skill: '',//专业技能特长
        ExperiencePsychology: '',//任职经历及心理变化情况
        ProudEventAfterArmy: '',//参军后自豪的事情
        BadlEventAfterArmy: '',//参军后受挫的事情
        FatherDuty: '',//父亲职业
        FatherAge: '',//父亲年龄
        FatherState: '',//父亲身体状况: 健康、疾病、离世
        MotherDuty: '',//母亲职业
        MotherAge: '',//母亲年龄
        MotherState: '1',//母亲身体状况: 健康、疾病、离世
        ParentMerryState: '',//父母婚姻状态
        MedicalHistory: '',//父母病史
        HasSister: '',//姐妹: 有、无
        HasChildren: '',//子女: 有、无
        GrowFatherNature: '',//父亲性格 
        GrowFatherTrainWay: '',//父亲教养方式
        GrowMotherNature: '',//母亲性格
        GrowMotherTrainWay: '',//母亲教养方式
        GrowParentRelationship: '',//父母关系
        GrowFamilyMood: '',//家庭氛围
        GrowSupporterNature: '',//扶养人性格(非父母抚养)
        GrowSupporterTrainWay: '',//扶养人教养方式(非父母抚养)
        AccountType: '',//户口类型 0-农村 1-城市
        MarriageState: '',//婚姻状态
        ArmyType: '',//兵种
        Cliniclype: '',//军街
        Degree: '',// 文化程度
        Positionlevel: '',//职级
        DeptID: '',//部队名称
        EntryDate: '',//入伍时间
        Skil1Level: '',//技术职别
        Bak2: '',//文职级别
        State: '',//是否退役
        Bak3: '',//出生地
        Bak4: '',//生长地
        Bak5: '',//心理状况
        Bak6: '',//身体状况
        Bak7: '',//夫妻感情
        Bak8: '',//夫/妻病史
        Bak9: '',//个人爱好
        Bak10: '',//个人病史
        ZSelfIntroduction: '',//自我评价
        Bakl1: '',//家庭婚姻状说
        UserID: '',//军认证件号 
        Realname: '',//姓名
        Sex: '1',//性别
        Age: '',//年龄
        Phone: '',//联系方式
        Email: '',//电子邮件
        TheGuardian: '',//紧急联系人
        TheGuardianPhone: ''//紧急联系人电话
      },
      activeStep:1,
    }
  },
  
  components: {
    File_individual,
    File_record_list,
  },
  methods: {
    // 点击切换锚点
    jupm(id,i) {
      document.getElementById(id).scrollIntoView();
      this.activeStep = i;
    },

    handleScroll(e) {
      if (e.target.scrollTop < 1700) {
        this.activeStep = 1
      } else if ( e.target.scrollTop < 2000) {
        this.activeStep = 2
      } else {
        this.activeStep = 3
      }
    },
  },
  watch: {

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true); //监听滚动条
  }
}
</script>
<style>
  .Personal_file{height: 100%;overflow: auto;}
  .Personal_file_title{padding-top: 20px;margin-left: 10px;}
  .Personal_file_title p {background-color: rgba(0, 136, 255, 1);height: 30px;width: 6px;float: left;}
  .Personal_file_title h2{margin-left: 20px;font-size: 16px;}
  .Personal_file_left{float: left;width: 220px;height: calc(100% - 164px); background-color: rgb(255, 255, 255);position: fixed;top:108px;left: 230px;border: 1px solid #e3e5e8;}
  .Personal_file_left h1{padding: 10px;}
  .Personal_file_left ul{}
  .Personal_file_left ul li{height: 50px;width: 220px;line-height: 50px;}

  .Personal_file_right{float: right;width: 1200px;height: calc(100% - 0px);width: calc(100% - 240px);overflow: auto;}
  .File_record_list{float: right;width: 1200px;width: calc(100% - 240px);overflow: auto;background-color: #fff;height: 100%;}


  .Personal_file_right #General{min-height: 1738px;background-color: #fff;}
  .Personal_file_right #Grow {min-height: 506px;background-color: #fff;}
  .Personal_file_right #Army {min-height: 450px;background-color: #fff;}
</style>